<template>
  <div
    class="tree-column"
    v-bind:class="{border: border!== undefined}"
    v-bind:style="{ width: width + 'px', flex: flex}"
    v-if="flex"
  >
    <slot></slot>
  </div>
  <div
    class="tree-column"
    v-bind:class="{border: border!== undefined}"
    style="flex: 1"
    :style="{'max-width': type == 'checkbox' ? '55px' : ''}"
    v-else
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'column',
  props: {
    width: Number,
    field: String,
    label: String,
    flex: Number,
    border: String,
    type: String
  },
  data () {
    return {
      open: false
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss">
.tree-column {
  position: relative;
  padding: 12px 6px;
  // min-width: 72px;
  text-align: center;
  overflow: hidden;
  // background: #f5f7fa;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  box-sizing: border-box;
  &.border {
    border-right: 1px solid #eee;
  }
}
.resize-line {
  position: absolute;
  top: 0;
  right: -3px;
  width: 6px;
  height: 100%;
  cursor: col-resize;
}
</style>



// WEBPACK FOOTER //
// src/components/dragTreeTable/column.vue